<template>
  <div class="w-1/2 mx-auto">
    <label>
      DCL File
      <input
        class="w-full"
        type="file"
        id="file"
        ref="file"
        v-on:change="onChangeFileUpload()"
      />
    </label>
    <br />
    <div class="w-full mx-auto pt-4">
      <vs-button v-on:click="submitForm()">Upload</vs-button>
    </div>
    <div v-if="bverify" class="w-full mx-auto pt-4">
      <vs-input disabled class="inputx w-full" v-model="filename" />
      <div class="pt-4">
        <vs-button @click="onbverify">Verify</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary"
          >primary</vs-progress
        >
      </div>
    </div>
    <div v-if="verify" class="w-full mx-auto pt-6">
      <!-- <vs-input v-if="verify" class="inputx w-1/2 pt-4" v-model="declaration" /> -->
      <div class="vx-row">
        <div class="vx-col w-2/4">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Shipment Type</span>
              </div>
            </template>
            <vs-select autocomplete v-model="declaration" class="w-full">
              <vs-select-item
                v-for="dcl in dcls"
                :key="dcl.label"
                :value="dcl.label"
                :text="dcl.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <div class="-mt-2">
        <vs-button @click="onverify">Confirm</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary"
          >primary</vs-progress
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
img {
  max-height: 36px;
}
</style>
<script>
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      file: "",
      bverify: false,
      verify: false,
      progress: false,
      filename: null,
      declaration: null,
      dcls: [
        { label: "FCL", name: "FCL" },
        { label: "LCL", name: "LCL" },
      ],
    };
  },
  methods: {
    onbverify() {
      let vm = this;
      this.progress = true;
      let formData = {
        filename: this.filename,
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
      };

      axios
        .post("/ApiBInbUpVerify", formData)
        .then((res) => {
          // console.log(res.data.message);
          if (res.data.status == "false") {
            vm.$vs.notify({
              title: "Upload",
              text: res.data.message,
              color: "danger",
              position: "top-right",
              fixed: true,
            });
          } else {
            vm.$vs.notify({
              title: "Verify",
              text: "Verify Complete",
              color: "success",
              position: "top-right",
              time: 3000,
            });
            if (res.data.message != undefined) {
              vm.declaration = res.data.message;
            } else {
              vm.declaration = "";
            }
            vm.verify = true;
          }
          vm.progress = false;
        })
        .catch((err) => {
          // console.log(err);
          vm.$vs.notify({
            title: "Upload",
            text: err,
            color: "danger",
            position: "top-right",
            fixed: true,
          });
        });
    },
    onverify() {
      let vm = this;
      // console.log(this.declaration);
      if (this.declaration == "") {
        vm.$vs.notify({
          title: "Upload",
          text: "Please Check Shipment Type",
          color: "danger",
          position: "top-right",
          time: 3000,
        });
      } else {
        this.progress = true;
        let formData = {
          filename: this.filename,
          declaration: this.declaration,
          token: localStorage.getItem("token"),
          dbname: localStorage.getItem("dbname"),
        };

        axios
          .post("/ApiInbUpVerify2", formData)
          .then((res) => {
            // console.log(res.data.message);
            if (res.data.status == "false") {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "danger",
                position: "top-right",
                fixed: true,
              });
            } else {
              vm.$vs.notify({
                title: "Upload",
                text: res.data.message,
                color: "success",
                position: "top-right",
                time: 3000,
              });
            }

            vm.progress = false;
            vm.$emit("done");
          })
          .catch((err) => {
            // console.log(err);
            vm.$vs.notify({
              title: "Upload",
              text: err,
              color: "danger",
              position: "top-right",
              fixed: true,
            });
          });
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
            headers: { Authorization: "Bearer " + token.accessToken }
          });

          // console.log(response.data);
          this.userid = response.data.id;
          this.userRole = response.data.userRole;
          this.agentscode = response.data.agentscode;
          this.parentagent = response.data.parentagent;

          this.email = response.data.email;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
    async submitForm() {
      let vm = this;
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("filename", this.filename);
      formData.append("editor", this.email);
      

      // const formData = {
      //       file: this.file
      //     };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(formData);
      const response = await axios.post(
        `${BASE_API_URL}/reports/uploadDCL`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      // console.log(response.data);

      // axios
      //   .post("/ApiInbUpload", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then(function (res) {
      //     // console.log(data.data.filename);
      if (response.data.status == "false") {
        vm.$vs.notify({
          title: "Upload",
          text: response.data.message,
          color: "danger",
          position: "top-right",
          fixed: true,
        });
      } else {
        vm.$vs.notify({
          title: "Upload",
          text: response.data.message,
          color: "success",
          position: "top-right",
          time: 3000,
        });
      }
      //   })
      //   .catch(function () {
      //     // console.log("FAILURE!!");
      //     vm.$vs.notify({
      //       title: "Upload",
      //       text: "FAILURE!!",
      //       color: "danger",
      //       position: "top-right",
      //       fixed: true,
      //     });
      //   });
    },

    onChangeFileUpload() {
      // console.log(this.$refs.file.files[0].name);
      this.file = this.$refs.file.files[0];
      this.filename = this.$refs.file.files[0].name;
    },
  },
  mounted(){
      this.checkProfiles();
  }
};
</script>
